export * from './ProductsIndexTableRowOpenLightboxButton.types';
export { default as ProductsIndexTableRowOpenLightboxButton } from './ProductsIndexTableRowOpenLightboxButton';
